export default __webpack_public_path__ + "static/media/Screenshot.0acba500.png";